import "./SubscriptionPreferencesFormInput.scss";

import React, { useEffect, useRef } from "react";
import { useBemBlock } from "../../../../../common/utils/bemContext/bemContextHook";
import { ISubscriptionPreferencesFormInputProps } from "./SubscriptionPreferencesFormInputModel";
import { cl } from "@ngd-web/lv-utils/ui/classNames";

export function SubscriptionPreferencesFormInputComponent({
    className = null,
    IconElement,
    focused,
    focus,
    blur,
}: ISubscriptionPreferencesFormInputProps) {
    const [bl, el] = useBemBlock("usmSubscriptionPreferencesFormInput");
    const inputRef = useRef<HTMLInputElement>();

    useEffect(() => {
        if (focused) inputRef.current?.focus();
    }, [focused]);

    return (
        <div className={cl(className, bl())}>
            <input
                className={el("input")}
                onFocus={focus}
                onBlur={blur}
                ref={inputRef}
            />

            <div className={el("icon-holder")}>
                <IconElement
                    className={el("icon")}
                    color={focused ? "rgba(59, 66, 77, 0.6)" : "#D9D9D9"}
                    size="1.725rem"
                />
            </div>
        </div>
    );
}
